import { useContext } from 'react';

import { Alert, ModalTrigger, TextButton } from '@zillow/constellation-10';

import { RMWContext } from '../../../providers/RMWContext';

import { PropertiesSelectors } from '../../../selectors';
import { useSelector } from '../../../selectors/useSelector';

const FeedListingSourceBanner = () => {
  const { paths } = useContext(RMWContext);

  const {
    adproduct: { isUnpaid },
    feedName,
    isFeed,
    active,
    listingAlias,
    topDupesDetails: { hasManualDupe, sourceCount },
  } = useSelector((state) => PropertiesSelectors.makeCurrentProperty(state));

  if (!isFeed) {
    return null;
  }

  const handleGoToListingSource = () => {
    window.router.transitionTo(`${paths.propertiesPage}/${listingAlias}/${paths.propertyDetailsSources}`);
  };

  let bodyText;
  let ctaText;
  let handleOnClick;
  if (!hasManualDupe) {
    bodyText = `This listing comes from ${feedName} and must be edited there.`;
    handleOnClick = null;
    if (!isUnpaid) {
      bodyText +=
        " If you'd like to use Zillow Rental Manager to edit and manage your listing instead, copy and publish your listing.";
      ctaText = 'Automatically copy and create a new version';
    }
  } else if (active) {
    bodyText = `${feedName} is the source for this version of the listing,
            which is currently visible to renters. To change the listing source,
            publish the version of the listing you want users to see.`;
    ctaText = 'Manage listing sources';
    handleOnClick = handleGoToListingSource;
  } else {
    bodyText = `${feedName} is the source for this version of the listing,
            which is not currently visible to renters. The address has ${sourceCount} listing sources.`;
    ctaText = 'Manage listing sources';
    handleOnClick = handleGoToListingSource;
  }

  const cta = ctaText ? <TextButton onClick={() => handleOnClick?.()}>{ctaText}</TextButton> : null;

  return (
    <Alert
      tone="info"
      actionButton={
        !hasManualDupe ? <ModalTrigger multiModalTriggerId="TransferFeedListingModal">{cta}</ModalTrigger> : cta
      }
      css={{ marginBottom: '600' }}
    >
      {bodyText}
    </Alert>
  );
};

export { FeedListingSourceBanner };
export default FeedListingSourceBanner;
